import { OctaneLogger } from '../integrations/datadog/OctaneLogger'
import { BrandConfig } from './types'

export async function importBrandedExperienceConfig(
    filename = 'default',
): Promise<BrandConfig> {
    const basePath = `/_branded`

    try {
        const importedConfig = await import(
            /* @vite-ignore */ `${basePath}/${filename}.js`
        )

        return importedConfig.BRAND_META as BrandConfig
    } catch (err) {
        OctaneLogger.error(`Branded Experience not found for: ${filename}`)
        throw err
    }
}
